// extracted by mini-css-extract-plugin
module.exports = {"main-container":"style_main-container__tkxZ_","trade-widgets-tabs":"style_trade-widgets-tabs__QDQbI"};